module.exports = __webpack_public_path__ + "img/MD.32899cea.svg";